module.exports = __webpack_public_path__ + "img/1.e3a8e5ff.jpg";